export const RESET_PASSWORD_TOKEN = 'reset_password_token';
